<template>
	<v-row>
		<v-col>
			<v-form v-model="formIsValid" ref="form">
				<faq-editor
						:faqs="faqData"
						:formRef="$refs.faqsForm"
						formText="These FAQs are organization-specific and will appear on the home page of the mobile pass."
						formTitle="Organization Specific FAQs"
						title="FAQs"
						@change="updateFaqs"
				/>
			</v-form>
			<save-form
					v-if="!faqDragging"
					:refs="$refs"
					:is-saving="isSaving"
					:is-valid="formIsValid"
					new-forms
					save-text="Save"
					@cancel-action="cancelChanges"
					@save-action="saveChanges"
			></save-form>
			<confirm-dialog
					:open="exitDialog"
					description="Your changes have not been saved. Leaving now will discard them."
					title="Unsaved Changes"
					@cancel="() => exitDialog = false"
					@confirm="doCancelChanges"
			></confirm-dialog>
		</v-col>
	</v-row>
</template>

<script>
import ConfirmDialog from '@app/Shared/UI/ConfirmDialog.vue';
import FaqEditor from '@app/Shared/Components/FaqEditor.vue';

export default {
	name: 'ChannelFaqs',
	components: {
		ConfirmDialog,
		FaqEditor
	},
	props: {
		channel: {
			type: Object,
			default: () => ({})
		},
		partner: {
			type: Object | null,
			default: null
		},
		returnUrl: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			exitDialog: false,
			faqDragging: false,
			formIsValid: false,
			isDirty: false,
			isSaving: false,
			faqData: []
		}
	},
	created() {
		this.faqData = this.setDefaultValues(this.channel);
	},
	mounted() {
		window.EventBus.$on('faq-drag-start', this.onDragStart);
		window.EventBus.$on('faq-drag-end', this.onDragEnd);
	},
	methods: {
		cancelChanges() {
			if(this.isDirty) {
				this.exitDialog = true;
			}
			else {
				this.doCancelChanges();
			}
		},
		doCancelChanges() {
			window.location = this.getReturnUrl();
		},
		getReturnUrl() {
			return `/partner-portal/${this.partner.id}/channels`;
		},
		setDefaultValues(channel) {
			const channelFaqs = this.channel.faqs
					? cloneDeep(this.channel.faqs)
					: cloneDeep(this.channel.const.DEFAULT_FAQS);

			const defaultQuestions = {
				'how-to-add-pass-to-my-phone': { 'question': 'How do I add the pass to my phone?' },
				'how-to-enable-location-services': { 'question': 'How do I enable location services?' },
			};

			return channelFaqs.map((item) => {
				if(item.code) {
					const newQuestion = defaultQuestions[item.code] || {};
					const newAnswer = { answer: '<<The answer is not editable and depends on the device>>' };
					return { ...item, ...newQuestion, ...newAnswer };
				}
				return item;
			});
		},
		onDragEnd() {
			this.faqDragging = false;
		},
		onDragStart() {
			this.faqDragging = true;
		},
		saveChanges() {
			// Validate first...
			this.$refs.form.validate();
			if(!this.formIsValid) return;

			this.isSaving = true;

			let url = `/partner-portal/${this.partner.id}/channels/save-channel/${this.channel.id || ''}`;
			axios.put(url, this.channel).then(response => {
				this.channel.id = response.data.channel.id;
				window.EventBus.$emit('system-messages', [
					{
						message: `${this.channel.name} ${!!this.channel.id
								? 'updated'
								: 'created'} - redirecting now ...`,
						messageType: 'success',
						showOverlay: true
					}
				]);
				setTimeout(() => {
					window.location = this.getReturnUrl();
				}, 2000);
			}).catch(error => {
				this.isSaving = false;
				window.EventBus.$emit('system-messages', [
					{ message: error.message, messageType: 'error' }
				]);
			});
		},
		updateFaqs(faqs) {
			this.isDirty = true;
			this.$set(this.channel, 'faqs', faqs);
		}
	}
};

</script>
